export const DATE_TIME_FORMAT = 'DD MMM YYYY HH:mm'
export const DATE_FORMAT = 'DD MMM YYYY'
export const MONTH_FORMAT = 'MMM YYYY'
export const TITLE_DAY_FORMAT = 'DD MMMM'
export const TITLE_DAY_MONTH_FORMAT = 'DD MMM'
export const TIME_FORMAT = 'HH:mm'
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
export const RANGE_DATE_FORMAT = 'DD MMM YYYY'
